import styled from 'styled-components';

export const Logo = styled.img`
  width: 250px;
  margin-bottom: 50px;
  @media (max-width: ${({theme}) =>theme.mobile}){
    display:none;
  }
`;
